__turbopack_context__.v({
  "link": "ThingsToDoShelfContainer-module-scss-module__AcdB8G__link",
  "root": "ThingsToDoShelfContainer-module-scss-module__AcdB8G__root",
  "title": "ThingsToDoShelfContainer-module-scss-module__AcdB8G__title",
});
